import type {
  CreateAdjustmentRequestDto,
  CreateBillingFolioRequestDto,
  CreateRefundRequestDto,
  GenerateBillingInvoiceRequestDto,
  PostFolioChargeRequestDto,
  SettleFolioBalanceRequestDto,
} from "./dtos.ts";

function requireValue(value: string | undefined, message: string) {
  return value?.trim() ? "" : message;
}

export function validateCreateBillingFolioRequest(request: CreateBillingFolioRequestDto) {
  return {
    folioId: requireValue(request.folioId, "Folio id is required."),
    guestId: requireValue(request.guestId, "Guest is required."),
    currency: requireValue(request.currency, "Currency is required."),
  };
}

export function validatePostFolioChargeRequest(request: PostFolioChargeRequestDto) {
  return {
    folioId: requireValue(request.folioId, "Folio is required."),
    description: requireValue(request.description, "Description is required."),
    amount: request.amount > 0 ? "" : "Amount must be greater than zero.",
    currency: requireValue(request.currency, "Currency is required."),
  };
}

export function validateSettleFolioBalanceRequest(request: SettleFolioBalanceRequestDto) {
  return {
    folioId: requireValue(request.folioId, "Folio is required."),
    allocations:
      request.allocations.length > 0 && request.allocations.every((entry) => entry.amount > 0)
        ? ""
        : "At least one positive payment allocation is required.",
    currency: requireValue(request.currency, "Currency is required."),
  };
}

export function validateCreateRefundRequest(request: CreateRefundRequestDto) {
  return {
    folioId: requireValue(request.folioId, "Folio is required."),
    paymentId: requireValue(request.paymentId, "Payment is required."),
    amount: request.amount > 0 ? "" : "Refund amount must be greater than zero.",
    reason: requireValue(request.reason, "Refund reason is required."),
  };
}

export function validateCreateAdjustmentRequest(request: CreateAdjustmentRequestDto) {
  return {
    folioId: requireValue(request.folioId, "Folio is required."),
    amount: request.amount > 0 ? "" : "Adjustment amount must be greater than zero.",
    reason: requireValue(request.reason, "Adjustment reason is required."),
  };
}

export function validateGenerateBillingInvoiceRequest(request: GenerateBillingInvoiceRequestDto) {
  return {
    folioId: requireValue(request.folioId, "Folio is required."),
  };
}
